import Promise from 'promise-polyfill';
if (typeof window === 'object') {
  window.Promise = window.Promise || Promise;
}
import 'whatwg-fetch';
import {warnAndReturn} from './utils';
import {defaultProfileImage} from './config';
import {domains} from './data/constants.json';

const conductExperiments = {
  'specs.fw.ExperimentalLanguagesToggle_languages': '',
  'specs.marketing.EnableAnonMainFunnelIntroLinks': 'false',
  'specs.funnel.NewHeaderAccessibilityChanges': 'false',
  'specs.funnel.EnableNewWixHeader': 'A',
  'specs.funnel.EnableNewLanguagesInWixHeader': 'false'
};

export const i18n = config =>
  fetch(`${config.baseUrl}assets/locale/messages/messages_${config.language}.json`)
    .then(response => response.json())
    .catch(warnAndReturn('Error getting i18n files', null));

export const userDetails = () =>
  fetch(window.__DEBUG__ ? `/userDetails` : `//${domains.wixManaged}/_api/wix-html-login-webapp/user/getUserDetails`, {
    headers: new Headers({Accept: 'application/json'}),
    cache: 'no-store',
    credentials: 'include'})
    .then(response => response.json())
    .then(response => response.success && response.errorCode === 0 ? response.payload : null)
    .catch(warnAndReturn('Error getting user details', null));

export const profileImage = config =>
  fetch(window.__DEBUG__ ? `/userImage` : `//${domains.wixManaged}/_api/account-info-server/profileimage`, {
    headers: new Headers({Accept: 'application/json'}),
    credentials: 'include'})
    .then(response => response.json())
    .then(response => response.profileImage || defaultProfileImage(config))
    .catch(warnAndReturn('Error getting profile image, set to default', defaultProfileImage(config)));

const experiment = (experiment, fallback) =>
  fetch(`${window.__DEBUG__ ? `/petri` : `//${domains.wixManaged}/_api/wix-laboratory-server/laboratory/conductExperiment`}?key=${experiment}&fallback=${fallback}`, {
    headers: new Headers({Accept: 'application/json'}),
    credentials: 'include'})
    .then(response => response.text())
    .catch(warnAndReturn(`Error fetching experiment ${experiment}`, conductExperiments[experiment]));

export const experiments = () =>
  Promise.all(Object.keys(conductExperiments).map(key => {
    return experiment(key, conductExperiments[key]);
  }))
    .then(values => values.reduce((experiments, value, index) => {
      experiments[Object.keys(conductExperiments)[index]] = value;
      return experiments;
    }, {}))
    .catch(() => conductExperiments);
